export const ADD_SETTING = 'ADD_SETTING'
export const UPDATE_SETTING = 'UPDATE_SETTING'
export const REMOVE_SETTING = 'REMOVE_SETTING'
export const REMOVE_ALL_SETTINGS = 'REMOVE_ALL_SETTINGS'
